import { Injectable } from "@angular/core";
import { RestReadServiceBase } from "@definitiv-packages/angular-dba-library";
import { TodoModelView } from "../../types/todo-model";
import { BehaviorSubject, catchError, concatMap, EMPTY, interval, switchMap, takeUntil } from "rxjs";
import { SafetyPointFormModelViewService } from "./SafetyPointFormModelView.service";
import { ObjektViewService } from "./ObjektModelView.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Injectable({
    providedIn: 'root'
})
export class TodoViewService extends RestReadServiceBase<TodoModelView> {
      public readonly todoCount$ = new BehaviorSubject(0);
    constructor(
       private  safetyPointFormModelViewService:SafetyPointFormModelViewService,
       private objektViewService : ObjektViewService,


    ) {
        super("TodoModelView", false);

        /*
        interval(5000).pipe(
            switchMap(_ => {
                return this.getCountTodos();
            }),
            catchError((err) => {
                return EMPTY;
            }),
            takeUntilDestroyed()
        )
        .subscribe();
        */
    }

    public setCount(count : number){
        this.todoCount$.next(count);
    }

  public async getCountTodos() {

      try { 
          var resultList = await Promise.all([
              this.getList(),
              this.safetyPointFormModelViewService.getList(),  
              this.objektViewService.getList()
          ]) 
      
          var count = 0;
          resultList[0].forEach(elem=>{
              count += resultList[2].find(x=>x.ObjektID == elem.ObjektId)?.SafetyPointCount!;
          })
              
          var cntsafety = resultList[1].filter(x=>(resultList[0].map(y=>y.ObjektId).includes(x.ObjektID))).length;
          this.setCount(count-cntsafety)
     
      }
      catch(error) {
          console.error(error)
      }
  }       
}

